export const SHARED_ENDPOINTS = {
  AUTH: '/auth',
  CUSTOMER_SELECTION: '/user-apps',
  CONTENT: '/content',
  HOME: '/content/home',
  NEWS: '/content/news',
  CONCERN: '/content/concern',
  DASHBOARD: '/content/dashboard',
  CREATION_PROPERTY_DAMAGE: '/content/concern/ticket-creation/PROPERTY_DAMAGE',
  CREATION_CONCERN: '/content/concern/ticket-creation/PROPERTY_CONCERN',
  PASSWORD_RESET_SUCCESS_PAGE: 'auth/password-changed',
  PASSWORD_RESET_EMAIL_SENT_PAGE: 'auth/email-sent',
  HOMEPAGE_MODULE: '/content/news/homepage-module',
  CONTENT_DETAIL_PAGE: '/content/home/shared-content-details-page',
  ONBOARDING: '/onboarding',
  NEWS_ATTACHMENT_VIEW: '/content/news/attachment-view',
  TICKET_ATTACHMENT_VIEW: '/content/concern/ticket-attachment-view',
  OFFLINE: '/offline',
};
